import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
`;

const SpinnerWrapper = styled.div`
  position: relative;
  margin-bottom: 2rem;
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #C44900;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const PlaygroundIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  animation: ${bounce} 2s infinite;
`;

const LoadingText = styled.h2`
  color: #2c3e50;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
`;

const LoadingSubtext = styled.p`
  color: #636e72;
  font-size: 1rem;
  text-align: center;
  max-width: 400px;
  line-height: 1.5;
`;

interface LoadingSpinnerProps {
  message?: string;
  subtext?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Loading playgrounds...",
  subtext = "Please wait while we gather the latest playground information for you."
}) => {
  return (
    <LoadingContainer>
      <SpinnerWrapper>
        <Spinner />
        <PlaygroundIcon>🛝</PlaygroundIcon>
      </SpinnerWrapper>
      <LoadingText>{message}</LoadingText>
      <LoadingSubtext>{subtext}</LoadingSubtext>
    </LoadingContainer>
  );
};

export default LoadingSpinner;